import { hasTelegramWebApp } from './telegram';

export const appModes = {
  web: 'web',
  telegram: 'telegram',
} as const;

export type AppMode = (typeof appModes)[keyof typeof appModes];

function browserWindow() {
  return typeof window === 'undefined' ? undefined : window;
}

export function isTelegramMiniApp(target: Window | undefined = browserWindow()) {
  return hasTelegramWebApp(target);
}

export function getAppMode(target: Window | undefined = browserWindow()): AppMode {
  return isTelegramMiniApp(target) ? appModes.telegram : appModes.web;
}
